/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgConvertLead = (props: Props) => (
  <Icon viewBox="0 0 24 25" {...props}>
    <g fill="none">
      <path
        d="M12 2.1a3 3 0 1 0 0 6 3 3 0 0 0 0-6zm-1 3a1 1 0 1 1 2 0 1 1 0 0 1-2 0zm-2.791 5.306c-.46.477-.766 1.052-.955 1.694h-5.52l1.527 1.674c2.47 2.71 4.58 6.324 5.317 7.778l.278.548h6.007l.15-.82c.06-.329.273-.844.659-1.52.373-.657.866-1.389 1.41-2.132a49.916 49.916 0 0 1 3.157-3.854l1.526-1.674h-5.02c-.188-.642-.493-1.217-.954-1.694C14.883 9.464 13.564 9.1 12 9.1s-2.883.364-3.791 1.306zm1.44 1.388c.377-.391 1.058-.694 2.35-.694 1.294 0 1.975.303 2.352.694a1.7 1.7 0 0 1 .234.306h-5.17c.071-.118.15-.219.233-.306zm-3.5 2.306h11.159c-.6.72-1.242 1.53-1.84 2.347a25.152 25.152 0 0 0-1.534 2.322c-.251.44-.48.893-.649 1.331h-3.21c-.76-1.406-2.187-3.783-3.926-6z"
        fill="currentcolor"
      />
    </g>
  </Icon>
);
export { SvgConvertLead as ConvertLead };
